import apiService from './api.service';

export interface Trace {
  id: string;
  application_id: string;
  trace_id: string;
  operation_name: string;
  timestamp: number;
  duration_ms: number;
  status: 'ok' | 'error';
  tags?: object;
  span_count: number;
  created_at: string;
}

export interface Span {
  id: string;
  trace_id: string;
  parent_span_id?: string;
  operation_name: string;
  span_kind: string;
  start_time: number;
  end_time: number;
  duration_ms: number;
  status: 'ok' | 'error';
  attributes?: object;
  events?: object[];
  links?: object[];
  created_at: string;
}

export interface TraceQueryParams {
  startTime?: number;
  endTime?: number;
  status?: 'ok' | 'error';
  minDuration?: number;
  maxDuration?: number;
  operationName?: string;
  limit?: number;
  offset?: number;
}

class TraceApi {
  async getAll(
    applicationId: string,
    params?: TraceQueryParams
  ): Promise<{ success: boolean; data: Trace[]; meta: { total: number; limit: number; offset: number } }> {
    return apiService.get(`/v1/traces/applications/${applicationId}`, { params });
  }

  async getById(applicationId: string, id: string): Promise<{ success: boolean; data: Trace }> {
    return apiService.get(`/v1/traces/applications/${applicationId}/${id}`);
  }

  async getSpans(traceId: string): Promise<{ success: boolean; data: Span[] }> {
    return apiService.get(`/v1/traces/${traceId}/spans`);
  }

  async getStatistics(
    applicationId: string,
    startTime: number,
    endTime: number
  ): Promise<{ success: boolean; data: any }> {
    return apiService.get(`/v1/traces/applications/${applicationId}/statistics`, {
      params: { startTime, endTime },
    });
  }
}

export default new TraceApi();
